export default __webpack_public_path__ + "static/media/text_image.f629908b.png";